import { render, staticRenderFns } from "./verMasTexto.vue?vue&type=template&id=2ef58795&scoped=true"
import script from "./verMasTexto.vue?vue&type=script&lang=js"
export * from "./verMasTexto.vue?vue&type=script&lang=js"
import style0 from "./verMasTexto.vue?vue&type=style&index=0&id=2ef58795&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef58795",
  null
  
)

export default component.exports